import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../Common/InputText';
import Icon from '../Common/Icon';

class MultiValueInput extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            inputValue: "",
        }
    }

    // Validate email format
    isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault(); // Prevent form submission

            const email = this.state.inputValue.trim();
            if (email && this.isValidEmail(email) && !this.props.emails.includes(email)) {
                this.props.setEmails([...this.props.emails, email]);
                this.setState({ inputValue: "" }); // Clear input
            }
        }
    };

    handleRemoveEmail = (emailToRemove) => {
        this.props.setEmails(this.props.emails.filter((email) => email !== emailToRemove));
    };

    render() {
        return <>
    
            <InputText
                name="email"
                label="Email"
                type="text"
                placeholder="Type an email and press Enter"
                value={this.state.inputValue}
                onChange={(e) => this.setState({ inputValue: e.target.value })}
                onKeyDown={this.handleKeyDown}
                isDisabled={this.props.emails.length >= 5} />
                
            <div className="d-flex flex-wrap">
                {this.props.emails.map(email => (
                    <div key={email} className='pacer-badge-container m-1'>
                        <button type="button" key={email} className='pacer-badge' onClick={() => this.handleRemoveEmail(email)}>
                            <Icon name='trash-alt' />
                            <span className='pacer-status'>{email}</span>
                        </button>
                    </div>
                )) }
            </div>
        </>;
    }
}

MultiValueInput.propTypes = {
    emails: PropTypes.array,
    setEmails: PropTypes.func,
}

export default MultiValueInput;